import { GoogleAuthProvider } from 'firebase/auth';

export const googleAuthProvider = new GoogleAuthProvider();
googleAuthProvider.setCustomParameters({ prompt: 'select_account' });
